export default __webpack_public_path__ + "static/media/gamepad_icon.5ec95964.svg";